const shopperDtmMapper = require('./shopper-analytics-dtm-mapper');

class ShopperAnalytics {
    constructor(analytics) {
        this.analytics = analytics;
    }

    push(shopperService) {
        this.analytics.push({ data: { shopperDetails: shopperService }, shopperDtmMapper });
    }
}

module.exports = ShopperAnalytics;



// WEBPACK FOOTER //
// ./src/auth/shopper/analytics/shopper-analytics.service.js